<section class="cmn-innerpage-wrapper work-order-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <div
      [ngClass]="{ show: isDropdownOpen }"
      class="common-dropdown filter-position"
      #dropdown
    >
      <button class="close-dropdown" (click)="toggleDropdown($event)"></button>
      <form>
        <h6 class="cmn-popup-heading">Filter <span>Clear All</span></h6>
        <div class="filter-inner-content">
          <h2>Branch</h2>
          <div class="check-wrapper">
            <div class="check-box">
              <label class="checkbox-wrapper">
                <input type="checkbox" />
                test
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="btn-wrapper">
          <button class="cmn-apply-btn" type="submit">Apply</button>
        </div>
      </form>
    </div>
    <!-- Filter -->
  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Orders</li>
      <!-- <li
        class="edit"
        (click)="navigateToSendMail()"
        [class.loading]="isLoading"
      >
        <img
          src="assets/images/icons/icon-send.svg"
          alt="Mail"
          *ngIf="!isLoading"
        />
        <span *ngIf="!isLoading">Send to mail</span>
        <span *ngIf="isLoading">Loading...</span>
      </li> -->

      <!-- <li class="edit" (click)="navigateTo('/invoice/invoice-add')">
        <img src="assets/images/icons/icon-record.svg" alt="Record" /> Request
        Invoice
      </li> -->
      <!-- <li class="edit" (click)="toggleAttachFile($event)">
        <img
          src="assets/images/icons/icon-attach.svg"
          alt="Attach"
        />Attachments
      </li> -->
      <!-- <li>
        <mat-form-field>
          <mat-label>Generate PDF </mat-label>
          <mat-select>
            <mat-option (click)="genPdf(true)">With Price</mat-option>
            <mat-option (click)="genPdf(false)">Without Price</mat-option>
          </mat-select>
        </mat-form-field>
      </li> -->
    </ul>
    <!-- Attach File Dropdown -->
    <!-- <div
      [ngClass]="{ show: isAttacheFile }"
      class="attach-file-dropdown"
      #dropdown2
    >
      <button
        class="close-dropdown"
        (click)="toggleAttachFile($event)"
      ></button>
      <div>
        <h6 class="cmn-popup-heading">Attachments</h6>
        <ul class="text-wrapper">
          <li>new</li>
          <li>new1</li>
          <li>new2</li>
          <li>new3</li>
        </ul>
        <div class="file-uploads-type-wrapper">
          <h2>Upload File</h2>
          <div class="cmn-upload-box">
            <div class="form-wrapper">
              <mat-form-field>
                <mat-select
                  placeholder="Select Type"
                  (selectionChange)="onSelectType($event)"
                  formControlName="fileType"
                >
                  <mat-option value="QUOTATION">Quotation</mat-option>
                  <mat-option value="BOQ">BQO</mat-option>
                  <mat-option value="LPO">LPO</mat-option>
                  <mat-option value="DRAWING">Drawing</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="form-wrapper"
              *ngIf="attachmentType && attachmentType == 'DRAWING'"
            >
              <label>Link<span class="red">*</span></label>
              <mat-form-field>
                <input matInput placeholder="Paste Link Here" />
              </mat-form-field>
            </div>

            <div *ngIf="attachmentType && attachmentType != 'DRAWING'">
              <div class="upload-wrapper">
                <input multiple #fileInput type="file" style="display: none" />
                <button
                  class="cmn-choose-file-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <img
                    src="assets/images/icons/icon-add-color.svg"
                    alt="Icon Add"
                  />Choose a File
                </button>
              </div>
              <div class="uploaded-file">
                <h6>
                  <span> uploaded file</span>
                  <img
                    src="assets/images/icons/icon-close.svg"
                    alt="Close Icon"
                    (click)="handleRemoveFile()"
                  />
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          class="tab-custom-button"
          *ngFor="let salesOrder of allSalesOrder; let i = index"
          [class.active]="selectedTabIndex === salesOrder?.id"
          (click)="selectTab(salesOrder?.id)"
        >
          <div class="inn-box">
            <h2>{{ salesOrder?.customerData?.firstName + salesOrder?.customerData?.lastName  }}</h2>
            <h3>{{ salesOrder?.orderCode }}</h3>
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div *ngIf="detailsLoading">
        <div class="chart-tab-content">
          <div>Loading....</div>
        </div>
      </div>

      <div *ngIf="!detailsLoading">
        <div class="chart-tab-content">
          <div class="tab-inner">
            <div class="note-header">
              <div class="left-set">
                <h4>
                  {{ (singleWorkOrder?.customerData?.firstName + ' ' + singleWorkOrder?.customerData?.lastName) || 'N/A' }}
                </h4>
                <h3>
                  {{ singleWorkOrder?.customerData?.address || "N/A" }}
                </h3>
                <h3>{{ singleWorkOrder?.customerData?.city || "N/A" }}</h3>
              </div>
              <div class="right-set">
                <h2>SALES ORDER</h2>
                <h3>
                  <b>{{ singleWorkOrder?.orderCode || "N/A" }}</b>
                </h3>
                <h3>
                  {{ singleWorkOrder?.createdAt | date : "dd/MM/yyyy" }}
                </h3>
              </div>
            </div>

            <div class="journal-details">
              <div class="details-box">
                <h4>Branch Name</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.branchData?.branchName || "N/A" }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Branch Code</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.branchData?.branchCode || "N/A" }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Quote Ref</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.quoteData?.quoteCode || "N/A" }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Order Code</h4>
                <h5>:</h5>
                <h6>{{ singleWorkOrder?.orderCode || "N/A" }}</h6>
              </div>
              <div class="details-box">
                <h4>Order Date</h4>
                <h5>:</h5>
                <h6>{{ singleWorkOrder?.orderDate  | date : "dd/MM/yyyy"  }}</h6>
              </div>
              <div class="details-box">
                <h4>Total Amount</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.totalAmount != null ? ('AED ' + (singleWorkOrder.totalAmount | number:'1.2-2')) : '--' }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Received Amount</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.received != null ? ('AED ' + (singleWorkOrder.received | number:'1.2-2')) : '--' }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Balance Amount</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.balance != null ? ('AED ' + (singleWorkOrder.balance | number:'1.2-2')) : '--' }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Refund Amount</h4>
                <h5>:</h5>
                <h6>
                  {{ singleWorkOrder?.refund != null ? ('AED ' + (singleWorkOrder.refund | number:'1.2-2')) : '--' }}
                </h6>
              </div>
              <div class="details-box">
                <h4>Payment Status</h4>
                <h5>:</h5>
                <h6>{{ singleWorkOrder?.paymentStatus || "N/A" }}</h6>
              </div>
            </div>

            <!-- <div
              class="crdit-note-page-table"
              *ngIf="singleWorkOrder?.workOrderSOWs?.length"
            >
              <table>
                <tr>
                  <th>Description</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                </tr>
                <tr *ngFor="let item of singleWorkOrder?.workOrderSOWs">
                  <td>{{ item?.order }}</td>
                  <td>{{ item?.quantity }}</td>
                  <td>{{ item?.unit }}</td>
                </tr>
              </table>
            </div> -->
            <p class="signature">Authorized Signature <span></span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
